import { GLOBAL } from '../constants/global.const';

const cartUtils = {
    set(data) {
        localStorage.setItem(GLOBAL.CART_STORAGE, JSON.stringify(data));
        this.dispatch();
    },
    get() {
        return localStorage.getItem(GLOBAL.CART_STORAGE);
    },
    dispatch() {
        window.dispatchEvent(
            new StorageEvent('storage', { key: GLOBAL.CART_STORAGE })
        );
    },
    setNoDispatch(data) {
        localStorage.setItem(GLOBAL.CART_STORAGE, JSON.stringify(data));
    },
};

export default cartUtils;
